import { render, staticRenderFns } from "./Create-Customer.vue?vue&type=template&id=bf1d8792&scoped=true"
import script from "./Create-Customer.vue?vue&type=script&lang=js"
export * from "./Create-Customer.vue?vue&type=script&lang=js"
import style0 from "./Create-Customer.vue?vue&type=style&index=0&id=bf1d8792&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "bf1d8792",
  null
  
)

export default component.exports